import { SimpleDirectedGraph } from "../../graph/directed/simple-directed-graph";
import { MultiSetTreeNode } from "./multi-set-tree-node";
import { Node } from "../../graph/lib/node";
import { ColorTreeGrid } from "../colorTree/color-tree-grid";
import { Edge } from "../../graph/lib/edge";
import { TreeEdge } from "../lib/tree-edge";
/**
 * The class SubTreeBuilder extends the abstract 
 * class SimpleDirectedGraph and is responsible for 
 * representing a subtree.
 */
export abstract class MultiSetSubTreeBuilder extends SimpleDirectedGraph {
    protected depth: number;
    protected root: MultiSetTreeNode;
    protected allChildSizePerLevel: number;
    protected childSizePerLevel: number;
    static readonly minRow: number = 8;
    static readonly minCol: number = 13;


    constructor(root: MultiSetTreeNode, canvas: HTMLCanvasElement, depthArg?: number) {
        let depth: number = 0;
        let curNode: Node = root;
        let row: number = 0;
        let col: number = 1;

        while (curNode.getNeighbors().length > 0) {
            col = col*curNode.getNeighbors().length;
            curNode = curNode.getNeighbors()[0];
            if(curNode == undefined){
                break;
            }
            depth = depth + 1;
            
        }
        if(depthArg != undefined){
            depth = depthArg;
        }

        row = Math.max(depth * 2 + 3, MultiSetSubTreeBuilder.minRow);
        col = Math.max(col + 6, MultiSetSubTreeBuilder.minCol);

        super(canvas, row, col);

        this.setGrid(new ColorTreeGrid(row, col, canvas));
        if (root instanceof MultiSetTreeNode) {
            this.root = root;
        }
    }


    

    buildTree() {
        this.cloning();

      //  console.log("NODES: ---->");
        this.nodes.forEach(node => {
            if(node instanceof MultiSetTreeNode){
        //        console.log(node.getContent());
          //      console.log("Count child: " + node.getNeighbors().length)
            }
        })
        
        let rootCoor: [number,number] = this.getCTGrid().getRootCoordinates();
        this.root.changeCoordinates(rootCoor[0], rootCoor[1]);
        let levels: Node[][] = [];
        let curLevel: number = 1;
      
        levels[0] = [this.root];
        
        while(true){

            let sameLevel: Node[] = [];
            levels[curLevel-1].forEach(node => {
                node.getNeighbors().forEach(cur => {
                    sameLevel.push(cur);
                })
            });
            levels[curLevel] = sameLevel;
            if(sameLevel.length == 0){
                break;
            }
            curLevel = curLevel+1;
        }

        let rowLevel: number = rootCoor[0]+2;

        for(let i = 1; i < levels.length; i++){
            let distance: number = this.cols/(levels[i].length+1);
            for(let j = 0; j < levels[i].length; j++){
                levels[i][j].changeCoordinates(rowLevel, distance*(j+1));
            }

            rowLevel = rowLevel+2;
        }
        
        this.update();

    }
    addEdge(from: Node, to: Node): Edge{
        let treeEdge = new TreeEdge(from ,to)   
        this.edges.push(treeEdge);
        treeEdge.setNearFactor(1);
        return treeEdge;
    }
    private cloning() {
        let clonedRoot: Node = this.root.clone();
        let origToProcess: Node[] = [this.root];
        let clonestoProcess: Node[] = [clonedRoot];
        while (origToProcess.length > 0) {
            let parent = origToProcess.shift();
            let cloneParent = clonestoProcess.shift();

            this.nodes.push(cloneParent);

            let children: Node[] = parent.getNeighbors();

            for (let i = 0; i < children.length; i++) {
                origToProcess.push(children[i]);
                let cloneChild = children[i].clone();

                cloneParent.addNeighbor(cloneChild);
                this.addEdge(cloneParent, cloneChild);
                clonestoProcess.push(cloneChild);
            }
        }

        if (clonedRoot instanceof MultiSetTreeNode) {
            this.root = clonedRoot;
        }

   
    }


    getCTGrid(): ColorTreeGrid {
        if (this.grid instanceof ColorTreeGrid) {
            return this.grid;
        }
    }
}
